// extracted by mini-css-extract-plugin
module.exports = {"Theme":"theme_Theme__1KsyP"};